var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-checkbox',{attrs:{"disabled":_vm.column.disabled},on:{"change":_vm.update},model:{value:(_vm.item[_vm.column.value]),callback:function ($$v) {_vm.$set(_vm.item, _vm.column.value, $$v)},expression:"item[column.value]"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }